import React from 'react';
import { Slide } from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css';
import { BaseDialog } from './BaseDialog.js';

const properties = {
    duration: 5000,
    transitionDuration: 500,
    infinite: true,
    indicators: true,
    arrows: true
};

const SlideShow = (slides) => (
    <div style={{ width: '100%' }}>
        <Slide {...properties}>
            {slides.map((key, i) => (
                <div className="each-slide" key={i}>
                    <div className="slides" style={{ 'backgroundImage': `url(${key})` }}>
                    </div>
                </div>
            ))}
        </Slide>
    </div>
);

export function DrazticDialog(data) {
    return (
        <BaseDialog thumbnail={data.thumbnail} title={data.title} text={data.text}>
            {SlideShow(data.slideImages)}
        </BaseDialog>
    );
}
